import React, { useState, useEffect } from 'react';
import './Hero.css';

import hero1 from '../assets/hero1.jpg';
import hero2 from '../assets/hero2.jpg';
import hero3 from '../assets/hero3.jpg';

const images = [hero1, hero2, hero3];

export default function Hero() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 8000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="hero-container">
      {images.map((img, index) => (
        <div
          key={index}
          className={`hero-slide ${index === currentIndex ? 'active' : ''}`}
          style={{ backgroundImage: `url(${img})` }}
          aria-hidden={index !== currentIndex}
        />
      ))}
      <div className="hero-overlay" />
      <div className="hero-text">
        <h1>Nos musiciens sont les meilleurs</h1>
        <p>Demandez leurs services</p>
      </div>
    </div>
  );
}
